import { Component, ChangeDetectionStrategy, ElementRef, inject, input } from '@angular/core';
import { NavigationModel } from '@app/shared/models';
import { HoverService } from './hover.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { SubitemNavComponent } from '../subitem-nav/subitem-nav.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-item-nav',
    templateUrl: './item-nav.component.html',
    styleUrls: ['./item-nav.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [HoverService],
    imports: [NgClass, RouterLinkActive, RouterLink, SubitemNavComponent, AsyncPipe, TranslatePipe],
})
export class NavItemComponent {
    private elementRef = inject(ElementRef);
    private hoverService = inject(HoverService);

    item = input.required<NavigationModel>();
    scrolling = input<boolean>(false);
    hover$ = this.hoverService.hoverNav$;

    onMouseEnter(): void {
        this.hoverService.hoverItem$.next(true);
    }

    onMouseLeave(): void {
        this.hoverService.hoverItem$.next(false);
    }

    onSubitemClick(): void {
        this.hoverService.hoverItem$.next(false);
    }

    get position(): DOMRect {
        return (<HTMLElement>this.elementRef.nativeElement).getBoundingClientRect();
    }

    get left(): number {
        return this.position.x + this.position.width;
    }

    get top(): number {
        return this.position.y - 18 + this.position.height / 2;
    }
}
